var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dynamic-page"},[(!_vm.isLoading)?_c('comp-render',{attrs:{"data":_vm.pageConf.components,"render-only":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }